import { Auth, Form } from '@livecontrol/core-ui';
import { Str } from '@livecontrol/core-utils';
import { User } from '@livecontrol/scheduler/model';
import { FormikProvider } from 'formik';
import qs from 'qs';
import type { ReactElement } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { store, Store } from '../../store';
import { useForm } from './form';

const Content = (): ReactElement => {
  const { formik, loading, alert } = useForm();
  const { awsCognitoUser } = store.getState();

  return (
    <>
      <Form.Alert show={alert.show} onClose={alert.hide}>
        {alert.message}
      </Form.Alert>

      <FormikProvider value={formik}>
        <Form>
          <p className='text-muted'>
            We have sent an e-mail to{' '}
            {awsCognitoUser?.getUsername() ?? 'the e-mail address you entered'} with a confirmation
            code. It may take up to 5 minutes to arrive; please check your spam folder if you do not
            see it. Please enter that code below.
          </p>
          <Form.Group name='email' label='E-mail Address' />

          <Form.Group
            name='code'
            label='Confirmation Code'
            controlProps={{
              autoFocus: true
            }}
          />

          <Form.Group
            name='password'
            label='New Password'
            controlProps={{
              type: 'password',
              maxLength: User.Constraints.PASSWORD_MAX_LENGTH
            }}
          />

          <Form.Group
            name='passwordConfirm'
            label='Confirm New Password'
            controlProps={{
              type: 'password',
              maxLength: User.Constraints.PASSWORD_MAX_LENGTH
            }}
          />

          <div className='d-flex align-items-center justify-content-between'>
            <Form.Submit className='btn-wide' loading={loading} size='lg'>
              Submit
            </Form.Submit>

            <Link className='font-size-13px' to='/login'>
              Back to Login
            </Link>
          </div>
        </Form>
      </FormikProvider>
    </>
  );
};

const Page = (): ReactElement => (
  <Auth.Layout>
    <Auth.Panel title='Confirmation' className='x-light-theme'>
      <Content />
    </Auth.Panel>
  </Auth.Layout>
);

export const ConfirmForgotPassword = (): ReactElement => {
  const { me } = Store.User.useIdentity();

  const redirectTo =
    Str.normalize(qs.parse(window.location.search, { ignoreQueryPrefix: true }).redirect) ?? '/';

  // Is the client already authenticated?
  return me ? <Redirect to={redirectTo} /> : <Page />;
};
